module.exports = __webpack_public_path__ + "img/verify.fe90fdfe.svg";